import React from 'react'
import { Modal } from 'antd'
import Lucide from './Lucide'
import './GiftModal.scss'

export default function GiftModal({
  visible,
  onClose,
  onStart,
  onLater
}: {
  visible: boolean
  onClose: () => void
  onStart: () => void
  onLater?: () => void
}) {
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      width={440}
      closable={false}
      mask={{ closable: true }}
      styles={{ body: { padding: 0 } }}
      className="aiClerk-gift-modal"
    >
      <div className="aiClerk-gift">
        <div className="aiClerk-gift__header">
          <span className="aiClerk-gift__glow" />

          <span className="aiClerk-gift__confetti aiClerk-gift__confetti--gold aiClerk-gift__confetti--c1" />
          <span className="aiClerk-gift__confetti aiClerk-gift__confetti--white aiClerk-gift__confetti--c2" />
          <span className="aiClerk-gift__confetti aiClerk-gift__confetti--pink aiClerk-gift__confetti--c3" />
          <span className="aiClerk-gift__confetti aiClerk-gift__confetti--gold aiClerk-gift__confetti--c4" />
          <span className="aiClerk-gift__confetti aiClerk-gift__confetti--white aiClerk-gift__confetti--c5" />
          <Lucide
            name="sparkle"
            size={14}
            className="aiClerk-gift__star aiClerk-gift__star--s1"
          />
          <Lucide
            name="sparkle"
            size={11}
            className="aiClerk-gift__star aiClerk-gift__star--s2"
          />
          <Lucide
            name="sparkles"
            size={14}
            className="aiClerk-gift__star aiClerk-gift__star--s3"
          />

          <div className="aiClerk-gift__gift-circle">
            <Lucide name="gift" size={34} className="aiClerk-gift__gift-icon" />
          </div>

          <button
            type="button"
            className="aiClerk-gift__close"
            onClick={onClose}
          >
            <Lucide name="x" size={16} />
          </button>
        </div>

        <div className="aiClerk-gift__body">
          <div className="aiClerk-gift__tag">
            <Lucide name="party-popper" size={13} />
            <span>团队专属 · 限时福利</span>
          </div>

          <h1 className="aiClerk-gift__h1">恭喜你获得 AI 填表员免费使用名额</h1>

          <p className="aiClerk-gift__sub">
            上传第一张表，照片和数据 AI 自动填好——名额已为你保留，开箱即用。
          </p>

          <div className="aiClerk-gift__coupon">
            <div className="aiClerk-gift__coupon-stub">
              <Lucide
                name="ticket"
                size={18}
                className="aiClerk-gift__coupon-stub-icon"
              />
              <span className="aiClerk-gift__coupon-stub-big">免费</span>
              <span className="aiClerk-gift__coupon-stub-small">试用名额</span>
            </div>

            <span className="aiClerk-gift__coupon-perf">
              <i className="aiClerk-gift__coupon-dot" />
              <i className="aiClerk-gift__coupon-dot" />
              <i className="aiClerk-gift__coupon-dot" />
              <i className="aiClerk-gift__coupon-dot" />
              <i className="aiClerk-gift__coupon-dot" />
            </span>
            <span className="aiClerk-gift__coupon-notch aiClerk-gift__coupon-notch--top" />
            <span className="aiClerk-gift__coupon-notch aiClerk-gift__coupon-notch--bottom" />

            <div className="aiClerk-gift__coupon-right">
              <span className="aiClerk-gift__coupon-title">
                AI 填表员 · 免费试填券
              </span>
              <span className="aiClerk-gift__coupon-desc">
                Excel / Word / 拼图都能体验填写
              </span>
              <span className="aiClerk-gift__coupon-limit-text">
                限时有效 · 已为你保留
              </span>
            </div>

            <span className="aiClerk-gift__coupon-limit">限领 1 张</span>
          </div>

          <div className="aiClerk-gift__social">
            <Lucide name="flame" size={13} />
            <span>已有 2 万+ 团队领取并在用</span>
          </div>

          <div className="aiClerk-gift__chips">
            <span className="aiClerk-gift__chip">
              <Lucide name="circle-check" size={13} />
              <span>填得准、对得上</span>
            </span>
            <span className="aiClerk-gift__chip">
              <Lucide name="circle-check" size={13} />
              <span>多格式都支持</span>
            </span>
            <span className="aiClerk-gift__chip">
              <Lucide name="circle-check" size={13} />
              <span>生成后可随手改</span>
            </span>
          </div>

          <button type="button" className="aiClerk-gift__cta" onClick={onStart}>
            <Lucide name="upload" size={17} />
            <span>立即领取并上传第一张表</span>
          </button>

          <button
            type="button"
            className="aiClerk-gift__later"
            onClick={onLater ?? onClose}
          >
            先随便逛逛
          </button>
        </div>
      </div>
    </Modal>
  )
}
